import React from 'react';
/////Material UI/////
import {Button, Grid, Stack, Typography, useTheme} from '@mui/material';
/////Local Shared Types//////
import {LogoSize, LogInType} from 'app/types/Shared';
import smallLogo from 'assets/images/header/elevateLogoSmall.svg';
import largeLogo from 'assets/images/header/ElevateLogoLarge.svg';
import takedaLogo from 'assets/images/header/takedaLogo.svg';
import Mountains from 'assets/images/background/ElevateBackgroundMountains.png';
/////React Router Dom/////
import {useNavigate} from 'react-router-dom';
///Local Components//////
import PageLayout from 'components/PageLayout/PageLayout';
import TopNavigation from 'components/TopNavigation/TopNavigation';
import PageFooterNav from 'components/Footer/PageFooterNav';
import {useMatomo} from '@jonkoops/matomo-tracker-react';

const LogoutPage = () => {
  const theme = useTheme();
  // Matomo Analytics
  const {trackPageView} = useMatomo();
  React.useEffect(() => {
    trackPageView();
  });

  const navigate = useNavigate();
  function Login(type: LogInType) {
    console.log('Login type: ' + type);
    if (type === LogInType.Internal) {
      navigate('/home');
    }
    return Promise.resolve();
  }

  function navigateHome() {
    navigate('/home');
    return Promise.resolve();
  }

  const header = (
    <TopNavigation
      authorized={false}
      login={Login}
      home={navigateHome}
      smallLogo={smallLogo}
      largeLogo={largeLogo}
      rightLogo={takedaLogo}
      LogoType={LogoSize.Large}
      banner={false}
    />
  );
  const footer = <PageFooterNav />;

  return (
    <PageLayout header={header} footer={footer}>
      <Grid container direction='row'>
        <Grid item xs={0.5} />
        <Grid
          item
          xs={11}
          sx={{
            backgroundImage: `url(${Mountains})`,
            backgroundSize: 'cover',
            backgroundPosition: 'left top',
            borderRadius: '12px',
            display: 'flex',
            marginTop: -5,
            justifyContent: 'center',
            alignItems: 'center',
            height: '80vh',
          }}
        >
          <Stack
            maxWidth='sm'
            spacing={4}
            marginTop={-15}
            py={4}
            px={6}
            alignItems='center'
            bgcolor={theme.palette.grey[200]}
            sx={{boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.25)'}}
          >
            <Typography gutterBottom variant='h1'>
              You have been logged out of ELEVATE
            </Typography>
            <Button variant='contained' sx={{px: 5, py: 1}} onClick={() => navigate('/home')}>
              Log In to Elevate
            </Button>
          </Stack>
        </Grid>
        <Grid item xs={0.5} />
      </Grid>
    </PageLayout>
  );
};

export default LogoutPage;
